import { useSelector } from 'react-redux';
import { replaceDomainForCacheKey } from '@americanexpress/fetchye-amex';
import { useFetchye } from 'fetchye';
import { getMycaMemberApiUrl } from '@/selectors/mycaSelectors';
import { getUserWallet } from '@/selectors/walletSelector';
import {
  mycaCardTypes,
  productUrlToProductTypeMap,
} from '@/constants/productMapping';

const isActiveAccount = (account) => {
  return account?.status?.account_status?.includes('Active');
};

const isActiveCenturionAccount = (account) => {
  return (
    account?.status?.account_status?.includes('Active') &&
    account?.product?.account_types?.includes('Centurion')
  );
};

// This function will return the account token of the first active Centurion account or the first active account
const getCenturionOrActiveToken = (body) => {
  const centurionAccountToken = body?.accounts?.find(
    isActiveCenturionAccount
  )?.account_token;
  const activeAccountToken =
    body?.accounts?.find(isActiveAccount)?.account_token;
  return centurionAccountToken || activeAccountToken;
};

export const useMemberAccountToken = () => {
  const url = useSelector(getMycaMemberApiUrl);

  const { data, error, isLoading } = useFetchye(url, {
    mapKeyToCacheKey: replaceDomainForCacheKey('myca'),
    credentials: 'include',
  });
  return {
    data: getCenturionOrActiveToken(data?.body),
    error,
    isLoading,
  };
};

export const useUserCardsWithLoungeAccess = () => {
  const wallet = useSelector(getUserWallet);
  const cardsWithLoungeAccess = wallet.filter((acct) => acct.hasLoungeBenefit);
  return cardsWithLoungeAccess;
};

export const useSelectedProductFromUserWallet = (productRouteParam) => {
  const wallet = useSelector(getUserWallet);
  const isValidCard = (cardType) =>
    Object.values(mycaCardTypes).includes(cardType);
  const cardsFromWalletThatMatchSelectedProductType = wallet.reduce(
    (validCards, acct) => {
      const acctTypeContainer = acct.product.type;
      const usersCardProductType = Array.isArray(acctTypeContainer[0])
        ? acctTypeContainer[0].find(isValidCard)
        : acctTypeContainer.find(isValidCard);
      if (
        usersCardProductType === productUrlToProductTypeMap[productRouteParam]
      ) {
        validCards.push(acct);
      }
      return validCards;
    },
    []
  );
  // if the URL in the browser is for a platinum card and the user has both a corporate and consumer platinum cards, pick the first one, they can change it with the card picker later.
  const selectedProductFromUserWallet =
    cardsFromWalletThatMatchSelectedProductType[0];
  return selectedProductFromUserWallet;
};
